module.exports = __webpack_public_path__ + "static/media/shop-gold-triangle-divider.b235e65b.png";